module.exports = __webpack_public_path__ + "static/media/coffee.a554109c.png";